import React, { useState, useRef, useEffect } from "react";
import { Col, Table, Form, Row, Tab, Tabs } from "react-bootstrap";

//components
import TableTemplate from "../../Components/TableTemplate/Table";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import ViewModal from "../../Components/Modals/ViewModal";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";
import toast from "react-hot-toast";
import { toastStyle, isAdmin, TokenExpiry } from "../../Helpers/Utils/Common";
import { useNavigate } from "react-router-dom";
import {
  getAllInventoryGroup,
  deleteInventoryGroup,
} from "../../Helpers/apiCalls/Manage/InventoryGroup";
import Footer from "../../Components/Footer/Footer";

export default function InventoryLevel() {
  const [inactive, setInactive] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  let navigate = useNavigate();

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // VIEW
  const [showViewBranchModal, setShowViewBranchModal] = useState(false);
  const handleShowViewBranchModal = () => setShowViewBranchModal(true);
  const handleCloseViewBranchModal = () => {
    setSelectedBranches([{}]);
    setShowViewBranchModal(false);
  };
  //API
  const [branchesData, setBranchesData] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    name: "",
    tab: "all",
    is_franchise: "",
  });
  const isInitialMount = useRef(true);
  const filterConfigKey = "manage-inventoryLevel-filterConfig";
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      setFilterConfig((prev) => {
        //
        if (window.localStorage.getItem(filterConfigKey) != null) {
          //
          handleTabSelect(
            JSON.parse(window.localStorage.getItem(filterConfigKey)).tab
          );
          return JSON.parse(window.localStorage.getItem(filterConfigKey));
        } else {
          return { ...prev };
        }
      });
    } else {
      window.localStorage.setItem(
        filterConfigKey,
        JSON.stringify(filterConfig)
      );
    }
  }, [filterConfig]);

  const [selectedRow, setSelectedRow] = useState({
    name: "",
    address: "",
    contact_person_no: "",
    phone_no: "",
    tin_no: "",
    bir_no: "",
    franchisee_name: "",
    franchisee_contact_no: "",
    contract_start: "",
    contract_end: "",
    opening_date: "",
    price_level: "",
    contact_person: "",
  });

  const [selectedBranches, setSelectedBranches] = useState([
    {
      id: "",
      name: "",
    },
  ]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return { ...prev, tab: tabKey };
    });
  };

  function renderViewTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {selectedBranches.map((selectedBranch, index) => {
            return (
              <tr>
                <td>{selectedBranch.label}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }


  async function searchInventoryGroup() {
    setShowLoader(true);
    setBranchesData([]);

    const response = await getAllInventoryGroup(filterConfig);
    if (response.data) {
      var inventoryLevel = [];
      var sortedData = response.data.data.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      sortedData.map(async (branch) => {
        var info = {};

        info.type = "";
        info.id = branch.id;
        info.name = branch.name;
        info.details = branch.details;
        info.no_of_branches = branch.inventory_group_details.length;
        info.inventory_group_details = branch.inventory_group_details;
        info.action_btn = ActionBtn(branch, "");
        inventoryLevel.push(info);
      });
      setBranchesData(inventoryLevel);
    } else if (response.error) {
      TokenExpiry(response);
    }

    setShowLoader(false);
  }

  async function handleDeleteItem() {
    setIsClicked(true);
    const response = await deleteInventoryGroup(selectedRow.id);
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      });
      handleCloseDeleteModal();
      searchInventoryGroup();
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data);
      })
    }
  }

  //DROPDOWN
  function handleSelectChange(e, row, type) {
    setSelectedRow(row);
    setSelectedType(type);

    var details = row.inventory_group_details.map((data) => {
      var info = data;
      info.name = "branch";
      info.label = data.branch_name;
      info.value = data.branch_id;
      info.entry = info;
      return info;
    });
    setSelectedBranches(details);
    if (e.target.value === "delete-branch") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-branch") {
      navigate("/inventorylevel/edit/" + row.id);
    } else if (e.target.value === "view-branch") {
      handleShowViewBranchModal();
    } else {
      handleShowDeleteModal();
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row}
        onChange={(e) => handleSelectChange(e, row, type)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-branch" className="color-options">
          View
        </option>
        {isAdmin && (
          <option value="edit-branch" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="delete-branch" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    );
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        value={"view-branch"}
        onClick={(e) => handleSelectChange(e, row, row.type)}
      >
        View
      </button>
    );
  }


  React.useEffect(() => {
    searchInventoryGroup();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE ITEM"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> Inventory Level </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="name"
              className="search-bar"
              // onChange={handleFilterChange}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
              placeholder="Search inventory level name..."
              />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
              <div className="PO-filters">
              <button
                className="add-btn"
                eventKey="braddex"
                onClick={() => navigate("/inventorylevel/add")}
              >
                Add
              </button>
              </div>
          </Col>
        </Row>
        {/* TABLE */}
        <div className="tab-content">
          <TableTemplate
            tableHeaders={["-", "GROUP NAME", "NO. OF BRANCHES", "ACTIONS"]}
            headerSelector={["-", "name", "no_of_branches", "action_btn"]}
            tableData={branchesData}
            showLoader={showLoader}
            ViewBtn={(row) => ViewBtn(row)}
            withActionData={true}
          />
        </div>
      </div>
      {/* MODALS */}
      <DeleteModal
        text="inventory level"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={() => handleDeleteItem()}
        isClicked={isClicked}
      />
      <ViewModal
        withButtons
        show={showViewBranchModal}
        onHide={handleCloseViewBranchModal}
        onEdit={() =>
          navigate(
            "/inventorylevel/edit/" + selectedRow.id
          )
        }
      >
        <div className="mt-0">
          <div className="col-sm-12 m-0 space container-wrapper">
            <Row className="nc-modal-custom-row-view mt-0">
              <Col>
                INVENTORY GROUP NAME
                <Row className="nc-modal-custom-row ms-2">
                  <Col>{selectedRow?.name || "N/A"}</Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="col-sm-12 m-0 space">
            <Row className="nc-modal-custom-row">
              <Col>BRANCHES</Col>
            </Row>
            <Row className="nc-modal-custom-row">
              <div className="edit-purchased-items">
                {selectedBranches.length === 0 ? (
                  <span>No Branch Found!</span>
                ) : (
                  renderViewTable()
                )}
              </div>
            </Row>
          </div>
        </div>
      </ViewModal>
      <Footer/>
    </div>
  );
}
